import {
    ClientBuilder,
    type ExistingTokenMiddlewareOptions,
    type HttpMiddlewareOptions,
} from "@commercetools/sdk-client-v2";
import { COMMERCETOOLS_API_URL } from "@lib/constants/urlConstants";
import fetch from "node-fetch";

const existingTokenFlowOption: ExistingTokenMiddlewareOptions = {
    force: true,
};

const httpMiddlewareOptions: HttpMiddlewareOptions = {
    host: COMMERCETOOLS_API_URL,
    fetch,
};

export const createCtpClient = (token: string) =>
    new ClientBuilder()
        .withExistingTokenFlow(`Bearer ${token}`, existingTokenFlowOption)
        .withHttpMiddleware(httpMiddlewareOptions)
        .build();
